module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<select class="base-select js-match">\n	';
 _.each(opponents, function(match) { 
__p+='\n	<option value="'+
((__t=( match.id ))==null?'':_.escape(__t))+
'"\n			'+
((__t=( match.is_selected ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n		'+
((__t=( match.label ))==null?'':_.escape(__t))+
'\n	</option>\n	';
 }) 
__p+='\n</select>\n';
}
return __p;
};
